const keys = {
    POST_USER_DETAIL: '/user',
    PATCH_USER_IDENTITY: '/user/username'
};

export default keys;

